import { Button, Icon } from "web/components"

import ScheduleMenuItem from "../ScheduleMenuItem/ScheduleMenuItem"
import { EXPORT_SCHEDULE_MODAL_TRIGGER_ID, MENU_ID } from "../constants"

export default function ScheduledExportMenu({
  scheduledExports,
  viewId,
  viewType,
}) {
  const hasScheduledExports = scheduledExports.length > 0

  const viewableType = viewType === "group" ? "ViewGroup" : "View"
  const newUrl = `/viewables/${viewableType}/${viewId}/scheduled_exports/new`
  const editUrlFor = (id) =>
    `/viewables/${viewableType}/${viewId}/scheduled_exports/${id}/edit`

  const openNewScheduleModal = () =>
    window.Turbo.visit(newUrl, { frame: "modal" })

  return (
    <div className="flex flex-col bg-white" data-testid={MENU_ID}>
      {hasScheduledExports && (
        <>
          <div className="space-y-2 p-3">
            {scheduledExports.map((scheduledExport) => (
              <ScheduleMenuItem
                key={scheduledExport.id}
                scheduledExport={scheduledExport}
                editUrl={editUrlFor(scheduledExport.id)}
              />
            ))}
          </div>
          <hr />
        </>
      )}

      <div className="p-3">
        <Button
          className="gap-1"
          testId={EXPORT_SCHEDULE_MODAL_TRIGGER_ID}
          onClick={openNewScheduleModal}
          variant="tertiary_default"
          size="small"
        >
          <Icon name="plus" />
          Create Scheduled Export
        </Button>
      </div>
    </div>
  )
}
